import { Search } from './control/search';

const search = (emptyText, geocoder) => new Search({
	emptyText: emptyText,
	geocoder: geocoder
});

const control_types = {
	Search, search
}

export {
	control_types
}